import { Component } from '@angular/core';
import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { TooltipDismissService } from './services/tooltip/tooltip-dismiss.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	providers: [DecimalPipe, CurrencyPipe, DatePipe],
	standalone: false,
})
export class AppComponent {
	title = 'EIF-Client';

	constructor(_tooltipDismissService: TooltipDismissService) {}
}
